import { useState, useEffect } from "react";

/**
 * useAuthVersion — "auth-changed" 이벤트마다 증가하는 버전 카운터.
 * 로그인/로그아웃 시 full reload 없이도 컴포넌트가 재렌더되도록 하는 용도.
 * 이 훅을 호출하는 컴포넌트는 auth-changed 발생 시 재렌더 → localStorage 기반
 * 로그인 상태/사용자 ID 를 다시 읽어 effect 를 재실행한다.
 */
export function useAuthVersion(): number {
  const [v, setV] = useState(0);
  useEffect(() => {
    const h = () => setV((x) => x + 1);
    window.addEventListener("auth-changed", h);
    return () => window.removeEventListener("auth-changed", h);
  }, []);
  return v;
}
